import React, { CSSProperties, useMemo } from 'react';
import { GetGroupParams } from '../../../helpers/renderGroups';
import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { indexToColumnLetter } from '../../../utils/area/area';
import {
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowLeft,
  MdOutlineKeyboardArrowRight,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';
import { IconType } from 'react-icons';
import { HeaderGroup } from '../../../types/sheet/headerGroups';
import { GridEntity } from '../../../types';
import { UseGridOperations } from '../../../hooks/useGridOperations';
import { t } from 'i18next';
import { SheetCommandType } from '../../../types/commands/sheetCommands/sheetCommands';

interface HeaderGroupProps
  extends GetGroupParams,
    Pick<UseGridOperations, 'openContextMenu'> {
  isColumn?: boolean;
  isRtl: boolean;
  isDarkTheme: boolean;
  zoom: number;
  // onClick: (
  //   op: GridOperations.Hide | GridOperations.Unhide,
  //   range: IRange
  // ) => void;
}
export const HeaderControllerView: React.FC<HeaderGroupProps> = (props) => {
  const {
    isClosed,
    isColumn = false,
    isRtl,
    x,
    y,
    width,
    height,
    group,
    isLastElementInViewport,
    isDarkTheme,
    zoom,
  } = props;
  const controllerContainerView = () => {
    const Icon = getArrowIcon(isRtl, isColumn, isClosed);
    // const groupName = getGroupName(group, isColumn);
    const borderRadius = '10px';
    const size = `${15 * zoom}px`;

    const op = isClosed
      ? SheetCommandType.UnhideGrid
      : SheetCommandType.HideGrid;
    const range = { start: group.start, end: group.end };
    const entityType = isColumn ? GridEntity.Column : GridEntity.Row;

    // <Tooltip
    //   label={`${isClosed ? 'Show' : 'Hide'} ${groupName}`}
    //   px={3}
    //   borderRadius={10}
    //   placement={isColumn ? 'top' : 'left'}
    //   isDisabled
    //   // closeOnClick={true}
    // >
    return (
      <Box
        style={{
          width: isColumn ? size : '100%',
          height: isColumn ? '100%' : size,
        }}
        cursor="pointer"
        transition="all .1s ease-in"
        bg={`${group.color ?? 'green'}.${isDarkTheme ? '800' : '200'}`}
        borderLeftRadius={isColumn ? borderRadius : undefined}
        borderTopRadius={isColumn ? undefined : borderRadius}
        opacity={0.9}
        as={Flex}
        alignItems="center"
        justifyContent="center"
        userSelect="none"
        _hover={{
          opacity: 1,
          transform: 'scale(1.1)',
        }}
        zIndex={2}
        onClick={
          () => {}
          // performGridOperation(entityType, { op, ranges: [range] })
        }
        onContextMenu={(e) =>
          props.openContextMenu(e, {
            entityType,
            group,
          })
        }
      >
        <Icon />
      </Box>
    );
  };
  // </Tooltip>

  return useMemo(
    () => (
      <Box
        style={getParentContainerStyle(props)}
        as={Flex}
        alignItems="center"
        justifyContent="flex-end"
        flexDirection={isColumn ? 'row' : 'column'}
      >
        {controllerContainerView()}
      </Box>
    ),
    [
      isClosed,
      isColumn,
      isRtl,
      x,
      y,
      width,
      height,
      group,
      isLastElementInViewport,
      isDarkTheme,
      zoom,
    ]
  );
};

export const HeaderGroupView: React.FC<HeaderGroupProps> = (props) => {
  const {
    isColumn = false,
    isRtl,
    x,
    y,
    width,
    height,
    group,
    isLastElementInViewport,
    //   ...props
    isDarkTheme,
    zoom,
  } = props;

  const range = { start: group.start, end: group.end };
  const entityType = isColumn ? GridEntity.Column : GridEntity.Row;

  const renderGroupTitle = (groupName: string) => {
    const style: CSSProperties = {
      overflow: 'hidden',
      fontSize: 14 * zoom,
    };
    if (!isColumn) {
      style.writingMode = 'vertical-lr';
      style.transform = isRtl ? 'scale(1)' : 'scale(-1)';
    }

    return (
      <span style={style}>
        {groupName}
        {/* Pakistan */}
        {/* پاکستان */}
        {/* گروپس */}
      </span>
    );
  };

  const renderGroupView = () => {
    const style: CSSProperties = {
      overflow: 'hidden',
    };

    const groupViewSize = 'calc(100% - 3px)';
    if (isColumn) {
      style.height = '100%';
      style.width = isLastElementInViewport ? groupViewSize : '100%';
    } else {
      style.width = '100%';
      style.height = isLastElementInViewport ? groupViewSize : '100%';
    }

    const borderRadius = '10px';

    const borderRightRadius =
      isColumn && isLastElementInViewport ? borderRadius : undefined;
    const borderBottomRadius =
      !isColumn && isLastElementInViewport ? borderRadius : undefined;

    const groupName = getGroupName(group, isColumn);

    return (
      <Tooltip
        label={groupName}
        px={3}
        borderRadius={10}
        placement={isColumn ? 'top' : 'left'}
      >
        <Box
          as={Flex}
          alignItems="center"
          justifyContent="center"
          fontSize="14px"
          bg={`${group.color ?? 'green'}.${isDarkTheme ? '700' : '100'}`}
          opacity={0.9}
          style={style}
          borderRightRadius={borderRightRadius}
          borderBottomRadius={borderBottomRadius}
          userSelect="none"
          onClick={
            (e) =>
              props.openContextMenu(e, {
                entityType,
                group,
              })
          
          }
          onContextMenu={(e) =>
            props.openContextMenu(e, {
              entityType,
              group,
            })
          }
          textTransform="capitalize"
        >
          {renderGroupTitle(groupName)}
        </Box>
      </Tooltip>
    );
  };

  return useMemo(
    () => (
      <Box style={getParentContainerStyle(props)} zIndex={1}>
        {renderGroupView()}
      </Box>
    ),
    [
      isColumn,
      isRtl,
      x,
      y,
      width,
      height,
      isLastElementInViewport,
      group,
      isDarkTheme,
    ]
  );

  //   return <></>;
};

const getParentContainerStyle = (props: HeaderGroupProps) => {
  const style: CSSProperties = {
    padding: props.isColumn ? '2px 0px' : '0px 2px',
    width: `${props.width}px`,
    height: `${props.height}px`,
    position: 'absolute',
    top: `${props.y}px`,
  };
  if (props.isRtl) style.right = `${props.x}px`;
  else style.left = `${props.x}px`;

  return style;
};

const getArrowIcon = (
  isRtl: boolean,
  isColumn: boolean,
  isClosed = false
): IconType => {
  if (isColumn) {
    if (isClosed) {
      if (isRtl) return MdOutlineKeyboardArrowLeft;
      else return MdOutlineKeyboardArrowRight;
    } else {
      if (isRtl) return MdOutlineKeyboardArrowRight;
      else return MdOutlineKeyboardArrowLeft;
    }
  } else {
    if (isClosed) return MdOutlineKeyboardArrowDown;
    else return MdOutlineKeyboardArrowUp;
  }
};

export const getGroupName = (group: HeaderGroup, isColumn: boolean) => {
  const start = isColumn ? indexToColumnLetter(group.start) : group.start + 1;
  const end = isColumn ? indexToColumnLetter(group.end) : group.end + 1;
  // const defaultTitle = isColumn
  //   ? `${indexToColumnLetter(group.start)} - ${indexToColumnLetter(group.end)}`
  //   : `${group.start + 1} - ${group.end + 1}`;

  return group.name
    ? group.name
    : t('header-groups.group', {
        start,
        end,
      });
};
